// extracted by mini-css-extract-plugin
module.exports = {"title":"Clients_title__3ccJa","list":"Clients_list__Yi6gL","logo":"Clients_logo__3viro"};